/**
 * Created by admin on 2018/7/2.
 */
import React from 'react';
import { Tooltip } from 'antd';
import './index.less';

export default ({ title, type, children, size, onClick, disabled, cls }) => {
  return (
    <Tooltip overlayClassName="table-icon-tip" title={title}>
      <i
        style={{ fontSize: size ? `${size}px` : `16px` }}
        className={`iconfont icon-${type} table-icon ${
          disabled ? 'icon-disabled' : ''
        } ${cls} ${!disabled && onClick ? 'icon-pointer' : ''}`}
        onClick={onClick}
      />
      {children}
    </Tooltip>
  );
};



// WEBPACK FOOTER //
// ./src/components/IconTip/index.js